module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/convenios/convenios.component.scss
// module id = ./src/app/components/convenios/convenios.component.scss
// module chunks = main